import React, { useState, Children } from 'react';
import { StoreIcon, DollarSignIcon, TruckIcon, TagIcon, HeartIcon, PercentIcon, PlusIcon, SearchIcon, ExternalLinkIcon, XIcon, EyeIcon, EyeOffIcon } from 'lucide-react';
interface Nonprofit {
  id: string;
  name: string;
  category: string;
  location: string;
  website: string;
  status: 'approved' | 'pending';
}
const StoreSettings = () => {
  const [donationType, setDonationType] = useState<'flat' | 'per-type'>('flat');
  const [donationMethod, setDonationMethod] = useState<'percentage' | 'fixed'>('percentage');
  const [flatDonation, setFlatDonation] = useState('');
  const [bookDonation, setBookDonation] = useState('');
  const [merchDonation, setMerchDonation] = useState('');
  const [selectedNonprofits, setSelectedNonprofits] = useState<string[]>([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [showAddForm, setShowAddForm] = useState(false);
  const [showDonationsPublicly, setShowDonationsPublicly] = useState(true);
  const [newNonprofit, setNewNonprofit] = useState({
    name: '',
    category: '',
    location: '',
    website: ''
  });
  const [showNoResultsForm, setShowNoResultsForm] = useState(false);
  const nonprofits: Nonprofit[] = [{
    id: '1',
    name: "Children's Literacy Foundation",
    category: 'Education',
    location: 'Vermont, USA',
    website: 'https://clifonline.org',
    status: 'approved'
  }, {
    id: '2',
    name: 'Book Access for All',
    category: 'Education',
    location: 'New York, USA',
    website: 'https://example.com',
    status: 'approved'
  }, {
    id: '3',
    name: 'Libraries First',
    category: 'Education',
    location: 'California, USA',
    website: 'https://example.com',
    status: 'approved'
  }, {
    id: '4',
    name: 'Rural Library Project',
    category: 'Education',
    location: 'Montana, USA',
    website: 'https://example.com',
    status: 'approved'
  }, {
    id: '5',
    name: 'Literacy for All',
    category: 'Education',
    location: 'Texas, USA',
    website: 'https://example.com',
    status: 'approved'
  }];
  return <div className="min-h-screen bg-gray-50 py-8" data-id="element-13839" data-mp="31zkd3vilihz1">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-13840" data-mp="31y97rr9i525t">
        <div className="text-center mb-8" data-id="element-13841" data-mp="2xyiar5tdtpsu">
          <h1 className="text-3xl font-bold text-gray-900" data-id="element-13842" data-mp="2xvcjpl170duh">Store Settings</h1>
          <p className="mt-2 text-lg text-gray-600" data-id="element-13843" data-mp="2a8e5yv4gjk09">
            Manage your store preferences
          </p>
        </div>
        <div className="grid gap-6 md:grid-cols-2" data-id="element-13844" data-mp="256owvl0spget">
          <div className="bg-white rounded-lg shadow-md p-6" data-id="element-13845" data-mp="2j181m347ow0a">
            <div className="flex items-center mb-4" data-id="element-13846" data-mp="2e9hoxqhsxw5p">
              <StoreIcon className="h-6 w-6 text-purple-600 mr-2" data-id="element-13847" data-mp="2e7ws1u80m14o" />
              <h2 className="text-xl font-semibold text-gray-900" data-id="element-13848" data-mp="1qjdmhmgco2ga">
                Store Details
              </h2>
            </div>
            <div className="space-y-4" data-id="element-13849" data-mp="1mhsb65jgrw87">
              <div data-id="element-13850" data-mp="1cedansu19nrx">
                <label className="block text-sm font-medium text-gray-700" data-id="element-13851" data-mp="1cdtp8256ch95">
                  Store Name
                </label>
                <input type="text" className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-purple-500 focus:ring-purple-500" data-id="element-13852" data-mp="1h5v9obchxea9" />
              </div>
              <div data-id="element-13853" data-mp="17fjx60eqxwrr">
                <label className="block text-sm font-medium text-gray-700" data-id="element-13854" data-mp="1v4uz3l7u1x7h">
                  Description
                </label>
                <textarea className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-purple-500 focus:ring-purple-500" rows={3} data-id="element-13855" data-mp="2047jlzb8es6w" />
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-md p-6" data-id="element-13856" data-mp="1q7urh5vc4me9">
            <div className="flex items-center mb-4" data-id="element-13857" data-mp="9qqj2lbzreuj">
              <HeartIcon className="h-6 w-6 text-purple-600 mr-2" data-id="element-13858" data-mp="eqlb4s7i6ah6" />
              <h2 className="text-xl font-semibold text-gray-900" data-id="element-13859" data-mp="erwews0y7i8a">
                Donation Settings
              </h2>
            </div>
            <div className="space-y-6" data-id="element-13860" data-mp="q7atsa3b791p">
              <div className="flex items-center justify-between p-4 bg-gray-50 rounded-lg" data-id="element-13861" data-mp="q6969653wu33">
                <div className="flex items-center" data-id="element-13862" data-mp="l8zg1o9w8ee7">
                  {showDonationsPublicly ? <EyeIcon className="h-5 w-5 text-purple-600 mr-3" data-id="element-13863" data-mp="g9wg2i8rsyd3" /> : <EyeOffIcon className="h-5 w-5 text-gray-400 mr-3" data-id="element-13864" data-mp="1dvkaixlo16lz" />}
                  <div data-id="element-13865" data-mp="18x8weaoc89xy">
                    <p className="font-medium text-gray-900" data-id="element-13866" data-mp="18y1wwtwpe37n">
                      Show on Profile & Products
                    </p>
                    <p className="text-sm text-gray-500" data-id="element-13867" data-mp="yzcr3zi3097r">
                      Display donation info publicly
                    </p>
                  </div>
                </div>
                <button onClick={() => setShowDonationsPublicly(!showDonationsPublicly)} className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${showDonationsPublicly ? 'bg-purple-600' : 'bg-gray-300'}`} data-id="element-13868" data-mp="3omk375nfwlsm">
                  <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${showDonationsPublicly ? 'translate-x-6' : 'translate-x-1'}`} data-id="element-13869" data-mp="295yzd4w79vkt" />
                </button>
              </div>
              <div data-id="element-13870" data-mp="2iuz2n0hqjd4t">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-13871" data-mp="2ixux2eudjjoi">
                  Donation Type
                </label>
                <div className="grid grid-cols-2 gap-3" data-id="element-13872" data-mp="2rvop3dl3vr5v">
                  <button onClick={() => setDonationType('flat')} className={`px-4 py-2 text-sm font-medium rounded-md ${donationType === 'flat' ? 'bg-purple-100 text-purple-700 ring-2 ring-purple-600' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-13873" data-mp="2ru4003hk90fe">
                    Flat Rate
                  </button>
                  <button onClick={() => setDonationType('per-type')} className={`px-4 py-2 text-sm font-medium rounded-md ${donationType === 'per-type' ? 'bg-purple-100 text-purple-700 ring-2 ring-purple-600' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-13874" data-mp="uhccjwr6xe5t">
                    Per Product Type
                  </button>
                </div>
              </div>
              <div data-id="element-13875" data-mp="1ddc270wp45m8">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-13876" data-mp="19dtj8aofq4m1">
                  Donation Method
                </label>
                <div className="grid grid-cols-2 gap-3" data-id="element-13877" data-mp="1n46rke58nlbw">
                  <button onClick={() => setDonationMethod('percentage')} className={`px-4 py-2 text-sm font-medium rounded-md ${donationMethod === 'percentage' ? 'bg-purple-100 text-purple-700 ring-2 ring-purple-600' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-13878" data-mp="1i656jno95bxs">
                    Percentage
                  </button>
                  <button onClick={() => setDonationMethod('fixed')} className={`px-4 py-2 text-sm font-medium rounded-md ${donationMethod === 'fixed' ? 'bg-purple-100 text-purple-700 ring-2 ring-purple-600' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-13879" data-mp="2boa6qddlaj9j">
                    Fixed Amount
                  </button>
                </div>
              </div>
              {donationType === 'flat' ? <div data-id="element-13880" data-mp="1wtnecux42mof">
                  <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-13881" data-mp="1wuyjay2am0h4">
                    Donation Amount{' '}
                    {donationMethod === 'percentage' ? '(%)' : '($)'}
                  </label>
                  <div className="mt-1 relative rounded-md shadow-sm" data-id="element-13882" data-mp="1939kqzyvofrq">
                    {donationMethod === 'fixed' && <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-13883" data-mp="1e2m77jlu7kts">
                        <span className="text-gray-500 sm:text-sm" data-id="element-13884" data-mp="1tjcflia70h0o">$</span>
                      </div>}
                    <input type="number" value={flatDonation} onChange={e => setFlatDonation(e.target.value)} className={`block w-full rounded-md border-gray-300 focus:border-purple-500 focus:ring-purple-500 ${donationMethod === 'fixed' ? 'pl-7' : ''}`} placeholder={donationMethod === 'percentage' ? '5' : '1.00'} data-id="element-13885" data-mp="1pjacr5sq1hjt" />
                    {donationMethod === 'percentage' && <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" data-id="element-13886" data-mp="wumxprykfoep">
                        <PercentIcon className="h-4 w-4 text-gray-400" data-id="element-13887" data-mp="rva1whppv6zz" />
                      </div>}
                  </div>
                </div> : <div className="space-y-4" data-id="element-13888" data-mp="csibtci15ddf">
                  <div data-id="element-13889" data-mp="crh3vgwb96zx">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-13890" data-mp="cucwqqtax5hi">
                      Book Sales Donation{' '}
                      {donationMethod === 'percentage' ? '(%)' : '($)'}
                    </label>
                    <div className="mt-1 relative rounded-md shadow-sm" data-id="element-13891" data-mp="rpsub5t3bjin">
                      {donationMethod === 'fixed' && <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-13892" data-mp="3q8gbjp4nlxoe">
                          <span className="text-gray-500 sm:text-sm" data-id="element-13893" data-mp="3v69hch21opo5">$</span>
                        </div>}
                      <input type="number" value={bookDonation} onChange={e => setBookDonation(e.target.value)} className={`block w-full rounded-md border-gray-300 focus:border-purple-500 focus:ring-purple-500 ${donationMethod === 'fixed' ? 'pl-7' : ''}`} placeholder={donationMethod === 'percentage' ? '5' : '1.00'} data-id="element-13894" data-mp="8qexmg3z7uog" />
                      {donationMethod === 'percentage' && <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" data-id="element-13895" data-mp="16s90a9bo836t">
                          <PercentIcon className="h-4 w-4 text-gray-400" data-id="element-13896" data-mp="1atm5qiauq4d7" />
                        </div>}
                    </div>
                  </div>
                  <div data-id="element-13897" data-mp="j50vdsi5mw5b">
                    <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-13898" data-mp="j2em9ofm88kz">
                      Merchandise Sales Donation{' '}
                      {donationMethod === 'percentage' ? '(%)' : '($)'}
                    </label>
                    <div className="mt-1 relative rounded-md shadow-sm" data-id="element-13899" data-mp="3rldtto24yw0e">
                      {donationMethod === 'fixed' && <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-13900" data-mp="3vkmkgk1vqdrq">
                          <span className="text-gray-500 sm:text-sm" data-id="element-13901" data-mp="3o0kf8kvyd9zb">$</span>
                        </div>}
                      <input type="number" value={merchDonation} onChange={e => setMerchDonation(e.target.value)} className={`block w-full rounded-md border-gray-300 focus:border-purple-500 focus:ring-purple-500 ${donationMethod === 'fixed' ? 'pl-7' : ''}`} placeholder={donationMethod === 'percentage' ? '5' : '1.00'} data-id="element-13902" data-mp="3f1qag78gxdao" />
                      {donationMethod === 'percentage' && <div className="absolute inset-y-0 right-0 pr-3 flex items-center pointer-events-none" data-id="element-13903" data-mp="2rakvduacqp1f">
                          <PercentIcon className="h-4 w-4 text-gray-400" data-id="element-13904" data-mp="2he81owet4b6o" />
                        </div>}
                    </div>
                  </div>
                </div>}
              <div data-id="element-13905" data-mp="2cpfcjk5o4oxc">
                <label className="block text-sm font-medium text-gray-700 mb-2" data-id="element-13906" data-mp="2cqqj1rqi0as5">
                  Supported Nonprofits
                </label>
                <div className="space-y-2 mb-4" data-id="element-13907" data-mp="1xuj1z0adzph3">
                  {/* Selected Nonprofits */}
                  <div className="space-y-2 mb-4" data-id="element-13908" data-mp="22tluxmd3e58p">
                    {selectedNonprofits.map(id => {
                    const nonprofit = nonprofits.find(np => np.id === id);
                    const donationSplit = donationType === 'flat' ? Number(flatDonation) / (selectedNonprofits.length || 1) : null;
                    if (!nonprofit) return null;
                    return <div key={nonprofit.id} className="flex items-center justify-between p-2 bg-purple-50 rounded-md" data-id="element-13909" data-mp="39dv9i1b3y0kh">
                          <div className="flex items-center space-x-2" data-id="element-13910" data-mp="12pcp4jec7feh">
                            <span className="text-sm font-medium text-gray-900" data-id="element-13911" data-mp="xs321aef7ftt">
                              {nonprofit.name}
                              {donationSplit && <span className="ml-2 text-xs text-purple-600" data-id="element-13912" data-mp="17jgy1875xxi7">
                                  (${donationSplit.toFixed(2)} per sale)
                                </span>}
                            </span>
                          </div>
                          <button onClick={() => setSelectedNonprofits(selectedNonprofits.filter(npId => npId !== nonprofit.id))} className="text-gray-400 hover:text-red-500 transition-colors" data-id="element-13913" data-mp="strr0wce2za0">
                            <XIcon className="h-4 w-4" data-id="element-13914" data-mp="2zild9243u3ky" />
                          </button>
                        </div>;
                  })}
                  </div>
                  {/* Search Input */}
                  <div className="relative" data-id="element-13915" data-mp="39hav4uw03o17">
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" data-id="element-13916" data-mp="39ey6xzznghfp">
                      <SearchIcon className="h-4 w-4 text-gray-400" data-id="element-13917" data-mp="3eeb2d94l6wtw" />
                    </div>
                    <input type="text" className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md leading-5 bg-white placeholder-gray-500 focus:outline-none focus:placeholder-gray-400 focus:ring-1 focus:ring-purple-500 focus:border-purple-500 sm:text-sm" placeholder="Search nonprofits..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} data-id="element-13918" data-mp="3ifmmx08lsrv8" />
                  </div>
                  {/* Search Results */}
                  {searchTerm && <div className="mt-2 max-h-60 overflow-auto border border-gray-200 rounded-md" data-id="element-13919" data-mp="1llmj3o2clwqg">
                      {nonprofits.filter(np => np.name.toLowerCase().includes(searchTerm.toLowerCase()) && !selectedNonprofits.includes(np.id)).map(nonprofit => <div key={nonprofit.id} onClick={() => setSelectedNonprofits([...selectedNonprofits, nonprofit.id])} className="flex items-center space-x-3 p-3 hover:bg-gray-50 border-b border-gray-200 cursor-pointer" data-id="element-13920" data-mp="1zgyhc5fpq5c4">
                            <div className="flex-1" data-id="element-13921" data-mp="qc95bl8txu9c">
                              <div className="flex items-center justify-between" data-id="element-13922" data-mp="bk8rimdntdfy">
                                <span className="text-sm font-medium text-gray-700" data-id="element-13923" data-mp="gjtnqp1g37oz">
                                  {nonprofit.name}
                                </span>
                                <a href={nonprofit.website} target="_blank" rel="noopener noreferrer" className="text-purple-600 hover:text-purple-700" onClick={e => e.stopPropagation()} data-id="element-13924" data-mp="6m77nz8eta3f">
                                  <ExternalLinkIcon className="h-4 w-4" data-id="element-13925" data-mp="1mymcnjh13esa" />
                                </a>
                              </div>
                              <div className="mt-1 flex items-center space-x-2" data-id="element-13926" data-mp="3cim78stnrkil">
                                <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium bg-purple-100 text-purple-700" data-id="element-13927" data-mp="37izs2du9ru75">
                                  {nonprofit.category}
                                </span>
                                <span className="text-xs text-gray-500" data-id="element-13928" data-mp="3hf2w5p8om2wq">
                                  {nonprofit.location}
                                </span>
                              </div>
                            </div>
                          </div>)}
                      {/* No results found message */}
                      {searchTerm && nonprofits.filter(np => np.name.toLowerCase().includes(searchTerm.toLowerCase()) && !selectedNonprofits.includes(np.id)).length === 0 && <div className="p-4 text-center" data-id="element-13929" data-mp="1jxucsmo88apr">
                            <p className="text-gray-500 mb-3" data-id="element-13930" data-mp="1oxqkox01omal">
                              No nonprofits found matching "{searchTerm}"
                            </p>
                            {!showNoResultsForm ? <button onClick={() => {
                      setShowNoResultsForm(true);
                      setNewNonprofit({
                        ...newNonprofit,
                        name: searchTerm
                      });
                    }} className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500" data-id="element-13931" data-mp="1yo1n2f42ynfd">
                                <PlusIcon className="-ml-0.5 mr-2 h-4 w-4" data-id="element-13932" data-mp="erdtgpoztwr3" />
                                Add "{searchTerm}" as new nonprofit
                              </button> : <div className="mt-4 p-4 bg-gray-50 rounded-md" data-id="element-13933" data-mp="5yiwskdld9cx">
                                <h4 className="text-sm font-medium text-gray-900 mb-4" data-id="element-13934" data-mp="10hew2rwjg31">
                                  Submit "{searchTerm}" for Approval
                                </h4>
                                <div className="space-y-4" data-id="element-13935" data-mp="3n7fpl46u0rn1">
                                  <div data-id="element-13936" data-mp="3j6lyk1y3ewpx">
                                    <label className="block text-sm font-medium text-gray-700" data-id="element-13937" data-mp="3j7oni4buup37">
                                      Organization Name
                                    </label>
                                    <input type="text" value={newNonprofit.name} onChange={e => setNewNonprofit({
                            ...newNonprofit,
                            name: e.target.value
                          })} className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-purple-500 focus:ring-purple-500 sm:text-sm" data-id="element-13938" data-mp="1he7iz9j0u4co" />
                                  </div>
                                  <div data-id="element-13939" data-mp="1hzuzgquj5b6a">
                                    <label className="block text-sm font-medium text-gray-700" data-id="element-13940" data-mp="1d2bgxeqsuc8j">
                                      Category
                                    </label>
                                    <select value={newNonprofit.category} onChange={e => setNewNonprofit({
                            ...newNonprofit,
                            category: e.target.value
                          })} className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-purple-500 focus:ring-purple-500 sm:text-sm" data-id="element-13941" data-mp="185l5x5tuq6tz">
                                      <option value="" data-id="element-13942" data-mp="2r2pu26pcoc9q">
                                        Select a category
                                      </option>
                                      <option value="Education" data-id="element-13943" data-mp="2w2uaxxu6790h">
                                        Education
                                      </option>
                                      <option value="Hunger" data-id="element-13944" data-mp="35zyrni58yc9w">Hunger</option>
                                      <option value="Domestic Violence" data-id="element-13945" data-mp="gao9kiicbvyo">
                                        Domestic Violence
                                      </option>
                                      <option value="Healthcare" data-id="element-13946" data-mp="2hbulmniiyjma">
                                        Healthcare
                                      </option>
                                      <option value="Environment" data-id="element-13947" data-mp="2ccrmfjp877m8">
                                        Environment
                                      </option>
                                      <option value="Arts" data-id="element-13948" data-mp="2mc8uu8vv3zlw">
                                        Arts & Culture
                                      </option>
                                    </select>
                                  </div>
                                  <div data-id="element-13949" data-mp="1tkp483wxrj9v">
                                    <label className="block text-sm font-medium text-gray-700" data-id="element-13950" data-mp="27e6mzmhssryu">
                                      Location
                                    </label>
                                    <input type="text" value={newNonprofit.location} onChange={e => setNewNonprofit({
                            ...newNonprofit,
                            location: e.target.value
                          })} className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-purple-500 focus:ring-purple-500 sm:text-sm" placeholder="City, State, Country" data-id="element-13951" data-mp="1ex42adbsrq3j" />
                                  </div>
                                  <div data-id="element-13952" data-mp="19knrfqt8vs36">
                                    <label className="block text-sm font-medium text-gray-700" data-id="element-13953" data-mp="19jvyknr188gl">
                                      Website
                                    </label>
                                    <input type="url" value={newNonprofit.website} onChange={e => setNewNonprofit({
                            ...newNonprofit,
                            website: e.target.value
                          })} className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-purple-500 focus:ring-purple-500 sm:text-sm" placeholder="https://" data-id="element-13954" data-mp="3u9lez57dw2be" />
                                  </div>
                                  <div className="flex justify-end space-x-3" data-id="element-13955" data-mp="sbd5zc2djhlw">
                                    <button type="button" onClick={() => {
                            setShowNoResultsForm(false);
                            setSearchTerm('');
                          }} className="inline-flex items-center px-3 py-2 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500" data-id="element-13956" data-mp="ndbnas8v1kay">
                                      Cancel
                                    </button>
                                    <button type="button" onClick={() => {
                            // Handle submission logic here
                            setShowNoResultsForm(false);
                            setSearchTerm('');
                            setNewNonprofit({
                              name: '',
                              category: '',
                              location: '',
                              website: ''
                            });
                          }} className="inline-flex items-center px-3 py-2 border border-transparent shadow-sm text-sm leading-4 font-medium rounded-md text-white bg-purple-600 hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500" data-id="element-13957" data-mp="27a0lfoyt04i4">
                                      Submit for Approval
                                    </button>
                                  </div>
                                </div>
                              </div>}
                          </div>}
                    </div>}
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-md p-6" data-id="element-13958" data-mp="1lhed1mfxtmv4">
            <div className="flex items-center mb-4" data-id="element-13959" data-mp="1giuu7uwn4r6z">
              <DollarSignIcon className="h-6 w-6 text-purple-600 mr-2" data-id="element-13960" data-mp="1gg8j5lajjtk0" />
              <h2 className="text-xl font-semibold text-gray-900" data-id="element-13961" data-mp="204d3be326b89">
                Payment Settings
              </h2>
            </div>
            <div className="space-y-4" data-id="element-13962" data-mp="1q5nusbx1y34o">
              <div data-id="element-13963" data-mp="1q4madgu5c4aa">
                <label className="block text-sm font-medium text-gray-700" data-id="element-13964" data-mp="1q55u933cx2qy">
                  Currency
                </label>
                <select className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-purple-500 focus:ring-purple-500" data-id="element-13965" data-mp="1v6ldqqpvz178">
                  <option data-id="element-13966" data-mp="1l6ueycuam01c">USD</option>
                  <option data-id="element-13967" data-mp="1l7vv2vq61cpx">EUR</option>
                  <option data-id="element-13968" data-mp="17ffzgfzlggz1">GBP</option>
                </select>
              </div>
              <div data-id="element-13969" data-mp="17dcyj0wwl3fj">
                <label className="block text-sm font-medium text-gray-700" data-id="element-13970" data-mp="1ce0w65fn0iiq">
                  Payment Methods
                </label>
                <div className="mt-2 space-y-2" data-id="element-13971" data-mp="xib9e52mo1cy">
                  <label className="flex items-center" data-id="element-13972" data-mp="12g3anpp5wztt">
                    <input type="checkbox" className="rounded text-purple-600 focus:ring-purple-500" data-id="element-13973" data-mp="12fl7sa7zvncx" />
                    <span className="ml-2" data-id="element-13974" data-mp="1dw9c5t357e1d">Credit Card</span>
                  </label>
                  <label className="flex items-center" data-id="element-13975" data-mp="18x66q7j935sv">
                    <input type="checkbox" className="rounded text-purple-600 focus:ring-purple-500" data-id="element-13976" data-mp="18vlckj0ulovj" />
                    <span className="ml-2" data-id="element-13977" data-mp="z0a5mmvollyc">PayPal</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-md p-6" data-id="element-13978" data-mp="u6p44kuvq9ue">
            <div className="flex items-center mb-4" data-id="element-13979" data-mp="q7gbxkfhmk0y">
              <TruckIcon className="h-6 w-6 text-purple-600 mr-2" data-id="element-13980" data-mp="l83rf6c39p1j" />
              <h2 className="text-xl font-semibold text-gray-900" data-id="element-13981" data-mp="l5r0w4s9m6cv">Shipping</h2>
            </div>
            <div className="space-y-4" data-id="element-13982" data-mp="gav5qvrqf2vj">
              <div data-id="element-13983" data-mp="b95upg4iep7g">
                <label className="block text-sm font-medium text-gray-700" data-id="element-13984" data-mp="bapaz6q61098">
                  Shipping Methods
                </label>
                <div className="mt-2 space-y-2" data-id="element-13985" data-mp="17tr87enfa5e">
                  <label className="flex items-center" data-id="element-13986" data-mp="640zw7yfizr1">
                    <input type="checkbox" className="rounded text-purple-600 focus:ring-purple-500" data-id="element-13987" data-mp="66n5w35o9775" />
                    <span className="ml-2" data-id="element-13988" data-mp="g1orip0qnr4z">Standard Shipping</span>
                  </label>
                  <label className="flex items-center" data-id="element-13989" data-mp="3elygetnjgq33">
                    <input type="checkbox" className="rounded text-purple-600 focus:ring-purple-500" data-id="element-13990" data-mp="3jjgsuu0rlnfu" />
                    <span className="ml-2" data-id="element-13991" data-mp="3ohi813v2l2m1">Express Shipping</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-lg shadow-md p-6" data-id="element-13992" data-mp="2vt2yuxymdeim">
            <div className="flex items-center mb-4" data-id="element-13993" data-mp="30t8tmn06rh4x">
              <TagIcon className="h-6 w-6 text-purple-600 mr-2" data-id="element-13994" data-mp="30rnz2xdvfy72" />
              <h2 className="text-xl font-semibold text-gray-900" data-id="element-13995" data-mp="2929w3v048l1c">Inventory</h2>
            </div>
            <div className="space-y-4" data-id="element-13996" data-mp="2e2furv4sz7sx">
              <div data-id="element-13997" data-mp="2e1ead01wd8yj">
                <label className="block text-sm font-medium text-gray-700" data-id="element-13998" data-mp="2dzjx87wval50">
                  Stock Management
                </label>
                <div className="mt-2 space-y-2" data-id="element-13999" data-mp="24372r7ti0397">
                  <label className="flex items-center" data-id="element-14000" data-mp="241vryo1mxv8l">
                    <input type="checkbox" className="rounded text-purple-600 focus:ring-purple-500" data-id="element-14001" data-mp="1qc1yttj3kot2" />
                    <span className="ml-2" data-id="element-14002" data-mp="1ge5srg50ok1t">Track Inventory</span>
                  </label>
                  <label className="flex items-center" data-id="element-14003" data-mp="1gcb6nyi0elw5">
                    <input type="checkbox" className="rounded text-purple-600 focus:ring-purple-500" data-id="element-14004" data-mp="1le0hpe58ezk8" />
                    <span className="ml-2" data-id="element-14005" data-mp="1bfkq7a2aloa7">Low Stock Alerts</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-6 flex justify-end" data-id="element-14006" data-mp="ssllvyvziqqj">
          <button className="bg-purple-600 text-white px-4 py-2 rounded-lg hover:bg-purple-700" data-id="element-14007" data-mp="nspio1v433c1">
            Save Changes
          </button>
        </div>
      </div>
    </div>;
};
export default StoreSettings;